import student from './student/index.vue'
export default {
  student
}
